<div class="flex w-full align-content-end justify-content-end">{{footerText}}</div>
